import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Pagination from "../Pagination/Pagination";
import moment from "moment";

function LogsModal(props) {
  return (
    <Modal
      isOpen={props.logsModal}
      toggle={props.logsModaltoggle}
      size="lg"
      centered
    >
      <ModalHeader toggle={props.logsModaltoggle}>Logs</ModalHeader>
      <ModalBody>
        <div style={{ width: "100%" }}>
          <table
            className="table tableData"
            style={{ margin: "0px" }}
          >
            <thead>
              <tr>
                <th>User</th>
                <th>Action</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {props.logs?.data?.map((item, index) => {
                return (
                  <tr key={"list" + index}>
                    <td>{item?.name}</td>
                    <td>{item?.action}</td>
                    <td>{moment(item?.log_date).format("lll")}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Pagination
          totalPost={props.logs?.total}
          postsPerPage={props.logs?.limit}
          setCurrentPage={(e) =>
            props.logsPage(props.logs?.data[0]?.dataId, e)
          }
          currentPage={props.logs?.pageNumber}
        />
      </ModalBody>
    </Modal>
  );
}

export default LogsModal;
